document.addEventListener('DOMContentLoaded', function () {

    const credibilityCarousel = document.querySelectorAll('.credibility-carousel');

    credibilityCarousel.forEach((element) => {
        if (element) {
            const swiper = new Swiper(element, {
                slidesPerView: 2,
                spaceBetween: 32,
                freeMode: true,
                breakpoints: {
                    800: {
                        slidesPerGroup: 3,
                        slidesPerView: 3,
                        grabCursor: true
                    },
                    1024: {
                        slidesPerGroup: 3,
                        slidesPerView: 5,
                        grabCursor: true
                    }
                }
            });
        }
    });

});